import { render, staticRenderFns } from "./PaymentsChart.vue?vue&type=template&id=af83e650&"
import script from "./PaymentsChart.vue?vue&type=script&lang=js&"
export * from "./PaymentsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports